import { isNil } from "client/Misc/utils";
import { useMemo } from "react";

export function useCallbackWithoutArguments(
	callback: () => void
): (...args: readonly unknown[]) => void;
export function useCallbackWithoutArguments(
	callback: (() => void) | undefined
): ((...args: readonly unknown[]) => void) | undefined;
export function useCallbackWithoutArguments(
	callback: (() => void) | undefined
): ((...args: readonly unknown[]) => void) | undefined {

	return useMemo(
		(): (() => void) | undefined => {
			if (isNil(callback)) {
				return undefined;
			}
			return () => callback();
		},
		[callback]
	);
}